export enum CookiesType {
	JWT = 'jwt',
	tempJWT = 'temp-jwt',
	UserId = 'userId',
	boImpersonateJWT = 'boImpersonateJWT',
	boImpersonateUserId = 'boImpersonateUserId',
}
